import { Languages } from '../types';

export const isValidLocale = (locale: string): locale is Languages => {
  return Object.values(Languages).includes(locale);
};
